export const quoteShellArg = (value: string) => `'${String(value).replace(/'/g, `'\\''`)}'`;

// For a value inside a double-quoted `sh -c "…"` script: adb's shell strips these backslashes,
// so the inner shell receives the value unchanged.
export const escapeForDoubleQuotes = (value: string) => value.replace(/[\\"$`]/g, "\\$&");

export const quoteForInnerShell = (value: string) => escapeForDoubleQuotes(quoteShellArg(value));
